export const roles = [
  { label: "admin", value: 1 },
  { label: "subadmin", value: 2 },
  { label: "user", value: 3 },
];
export const service_price_type = [
  { label: "Fixed", value: 1 },
  { label: "Size wise", value: 2 },
  // { label: "Cts wise", value: 3 },
];

export const additional_services = [
  { label: "without_plot", value: "without_plot" },
  { label: "tatkal", value: "tatkal" },
  { label: "color", value: "color" },
];

export const stone_status = [
  { value: 1, label: "submitted" },
  { value: 2, label: "resulted" },
  { value: 3, label: "recheck submited" },
  { value: 4, label: "recheck resulted" },
  { value: 5, label: "recut submited" },
  { value: 6, label: "recut resulted" },
  { value: 7, label: "party resulted" },
  { value: 8, label: "result replied" },
  { value: 9, label: "lab returned" },
  { value: 10, label: "certy recheck submited" },
  { value: 11, label: "certy recheck resulted" },
  { value: 12, label: "billing pending" },
  { value: 13, label: "billed" },
  { value: 14, label: "Non certy return" },
  { value: 15, label: "Ungraded return" },
];
export const bill_status = [
  { value: 0, label: "bill pending" },
  { value: 1, label: "bill drafted" },
  { value: 2, label: "bill confirmed" },
];
export const returned_status = [
  { value: 1, label: "bill pending" },
  { value: 2, label: "bill drafted" },
];
